// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + ({"581": "__federation_expose_ConstructorModule","650": "__federation_expose_AlertsModule","750": "__federation_expose_ReportsModule",}[chunkId] || chunkId) + "." + {"558": "8efc47db","581": "0a72326a","650": "164e41a9","750": "c8062355",}[chunkId] + ".css"
}